const { COUNTRIES } = require("../../constants");

const COUNTRIES_WITH_TVA_REQUIRED = [COUNTRIES.FR, COUNTRIES.IT, COUNTRIES.ES];

const getIsTVARelevantForCountry = country => {
  return COUNTRIES_WITH_TVA_REQUIRED.includes(country);
};

module.exports = { getIsTVARelevantForCountry };
